<template>
  <div class="col">
    <div class="row">
      <gmap-map
        class="col"
        id="map"
        :center="center"
        :zoom="12"
        :options="options"
        map-type-id="terrain"
        :disableDefaultUI="true"
      >
        <gmap-info-window
          :options="infoOptions"
          :position="infoWindowPos"
          :opened="infoWinOpen"
          @closeclick="infoWinOpen = false"
        >
        </gmap-info-window>
        <gmap-marker
          :key="cuenta"
          v-for="(tr, cuenta) in vehicles"
          :position="tr.center"
          :icon="tr.icon"
          :clickable="true"
          @click="toggleInfoWindow(tr, cuenta)"
        >
        </gmap-marker>
        <gmap-marker
          :key="id + '-tag'"
          v-for="(tr, id) in tags"
          :position="tr.center"
          :icon="tr.icon"
          :clickable="true"
          @click="toggleInfoWindow(tr, id)"
        >
        </gmap-marker>
      </gmap-map>
      <div id="list" class=".col-md-6 col-xl-auto">
        <div style="padding: 0 !important" class="container-fluid">
          <card>
            <div class="col-12">
              <div class="col">
                <h4 class="card-title"><strong>Ultimas Alertas</strong></h4>
              </div>
            </div>
            <table class="table">
              <thead>
                <tr>
                  <th style="display: flex; flex-direction: column">
                    <span>PLACA / </span>
                    <span>NOMBRE</span>
                  </th>
                  <th>KM/H</th>
                  <th>FECHA</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in eventsAlerts" :key="index">
                  <td>{{ item.placa }}</td>
                  <td>{{ Math.trunc(item.speed) }}</td>
                  <td>{{ item.date_event }}</td>
                  <td v-if="item.event == 32">
                    <img :src="require('../assets/velocidad-40.png')" />
                  </td>
                  <td v-if="item.event == 99">
                    <img :src="require('../assets/exclusion.png')" />
                  </td>
                  <td v-if="item.event == 98">
                    <img :src="require('../assets/inclusion.png')" />
                  </td>
                  <td v-if="item.event == 18">
                    <img :src="require('../assets/bateria-40.png')" />
                  </td>
                  <td v-if="item.event == 19">
                    <img :src="require('../assets/res_battery.png')" />
                  </td>
                  <td v-if="item.event == 21">
                    <img :src="require('../assets/panico-40.png')" />
                  </td>
                  <td v-if="item.event == 97">
                    <img :src="require('../assets/offline.png')" />
                  </td>
                  <td v-if="item.event == 96">
                    <img :src="require('../assets/online.png')" />
                  </td>
                </tr>
              </tbody>
            </table>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { API_KEY } from "./Maps/API_KEY";
import Card from "src/components/Cards/Card.vue";
import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";
import getSecret from "../helpers/get-secret";
import { getIconUrl } from "../helpers/iconHelper.js";
const serverUrl = getSecret("SERVER_URL");
Vue.use(VueGoogleMaps, {
  load: {
    key: API_KEY,
    libraries: "places,drawing,visualization",
  },
});
export default {
  components: {
    Card,
  },
  data() {
    return {
      id_company: JSON.parse(localStorage.getItem("jwt_licencia")).id_company,
      counter: JSON.parse(localStorage.getItem("jwt_licencia")).counter,
      vehicles: [],
      tags: [],
      eventsAlerts: "",
      center: {
        lat: 0,
        lng: 0,
      },
      infoWindowPos: null,
      infoWinOpen: false,
      infoOptions: {
        content: "",
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      options: {
        styles: [
          {
            featureType: "water",
            stylers: [
              { saturation: 43 },
              { lightness: -11 },
              { hue: "#0088ff" },
            ],
          },
          {
            featureType: "road",
            elementType: "geometry.fill",
            stylers: [
              { hue: "#ff0000" },
              { saturation: -100 },
              { lightness: 99 },
            ],
          },
          {
            featureType: "road",
            elementType: "geometry.stroke",
            stylers: [{ color: "#808080" }, { lightness: 54 }],
          },
          {
            featureType: "landscape.man_made",
            elementType: "geometry.fill",
            stylers: [{ color: "#ece2d9" }],
          },
          {
            featureType: "poi.park",
            elementType: "geometry.fill",
            stylers: [{ color: "#ccdca1" }],
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [{ color: "#767676" }],
          },
          {
            featureType: "road",
            elementType: "labels.text.stroke",
            stylers: [{ color: "#ffffff" }],
          },
          { featureType: "poi", stylers: [{ visibility: "off" }] },
          {
            featureType: "landscape.natural",
            elementType: "geometry.fill",
            stylers: [{ visibility: "on" }, { color: "#b8cb93" }],
          },
          { featureType: "poi.park", stylers: [{ visibility: "off" }] },
          {
            featureType: "poi.sports_complex",
            stylers: [{ visibility: "off" }],
          },
          { featureType: "poi.medical", stylers: [{ visibility: "off" }] },
          {
            featureType: "poi.business",
            stylers: [{ visibility: "off" }],
          },
        ],
      },
    };
  },
  methods: {
    getIcon(type, color) {
      const icon = {
        url: getIconUrl(type, color),
      };
      if (typeof google !== 'undefined' && google.maps && google.maps.Size) {
        icon.scaledSize = new google.maps.Size(32, 32);
      } else {
        icon.scaledSize = { width: 32, height: 32 };
      }
      return icon;
    },
    validateStatus() {
      this.axios
        .get(serverUrl + "/api/validateStatus/" + this.id_company)
        .then((res) => {
          if (res.data.info.licencia.status_commercial == "MORA") {
            window.localStorage.removeItem("jwt_user");
            window.localStorage.removeItem("jwt_licencia");
            window.localStorage.removeItem("jwt_token");
            location.href = location.origin + "/login";
          } else {
            let tipo = {
              name: res.data.info.licencia.name,
              id_company: res.data.info.licencia.id_company,
              payment_data: res.data.info.licencia.payment_data,
              status_commercial: res.data.info.licencia.status_commercial,
              counter: res.data.info.licencia.counter,
            };
            window.localStorage.setItem("jwt_licencia", JSON.stringify(tipo));
            if (this.counter != res.data.info.licencia.counter)
              location.reload();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setVehicles() {
      this.date = new Date();
      var numberOfMlSeconds = this.date.getTime();
      var addMlSeconds = 60 * 60000;
      this.endData = new Date(numberOfMlSeconds - addMlSeconds);
      if (this.vehicles) {
        this.vehicles.forEach((vehicle) => {
          if (vehicle.last_latitude != null) {
            this.center.lat = parseFloat(vehicle.last_latitude);
            this.center.lng = parseFloat(vehicle.last_longitude) * -1;
            vehicle.center = {
              lat: parseFloat(vehicle.last_latitude),
              lng: parseFloat(vehicle.last_longitude) * -1,
            };
          }
          if (vehicle.last_report != null) {
            if (vehicle.svg) {
              let color = vehicle.svg_color ? vehicle.svg_color : "#004aad";
              vehicle.icon = this.getIcon(vehicle.svg, color);
              if (Date.parse(vehicle.last_report) < Date.parse(this.endData)) {
                vehicle.status = "Desconectado";
              } else {
                vehicle.status = "Conectado";
              }
              if (vehicle.last_speed != "0") {
                vehicle.status = "En Movimiento";
              }
            } else {
              if (Date.parse(vehicle.last_report) < Date.parse(this.endData)) {
                vehicle.status = "Desconectado";
                vehicle.icon = {
                  url: "https://gps.isolutions.website/img/markerGrey.png",
                };
              } else {
                vehicle.status = "Conectado";
                vehicle.icon = {
                  url: "https://gps.isolutions.website/img/markerRed.png",
                };
                if (vehicle.last_speed != "0") {
                  vehicle.status = "En Movimiento";
                  vehicle.icon = {
                    url: "https://gps.isolutions.website/img/markerRedRight.png",
                  };
                }
              }
            }
          }
          vehicle.infoText =
            "<strong>Cuenta:</strong>" +
            vehicle.cuenta +
            "<br><strong>Placa:</strong>" +
            vehicle.placa +
            "<br><strong>Estado:</strong>" +
            vehicle.status +
            "<br><strong>Fecha:</strong>" +
            vehicle.last_report +
            "<br><strong>Velocidad:</strong>" +
            vehicle.last_speed;
        });
      }
      if (this.tags) {
        this.tags.forEach((tag) => {
          if (tag.last_latitude != null) {
            this.center.lat = parseFloat(tag.last_latitude);
            this.center.lng = parseFloat(tag.last_longitude);
            tag.center = {
              lat: parseFloat(tag.last_latitude),
              lng: parseFloat(tag.last_longitude),
            };
          }
          if (tag.last_report != null) {
            if (tag.svg) {
              let color = tag.svg_color ? tag.svg_color : "#004aad";
              tag.icon = this.getIcon(tag.svg, color);
            } else {
              if (Date.parse(tag.last_report) < Date.parse(this.endData)) {
                tag.status = "Desconectado";
                tag.icon = {
                  url: "https://gps.isolutions.website/img/markerGrey.png",
                };
              } else {
                tag.status = "Conectado";
                tag.icon = {
                  url: "https://gps.isolutions.website/img/markerRed.png",
                };
              }
            }
          }
          tag.infoText =
            "<br><strong>Nombre:</strong>" +
            tag.nickname +
            "<br><strong>Fecha posición:</strong>" +
            tag.last_report.slice(0, 16) +
            "<br><strong>Fecha consulta:</strong>" +
            tag.created_last_report.slice(0, 16).replace("T", " ");
        });
      }
    },
    getEventAlert() {
      this.axios
        .get(serverUrl + "/api/getEventAlert/" + this.id_company)
        .then((res) => {
          if (res.data.status == 200) {
            this.eventsAlerts = res.data.eventsAlert;
          } else {
            console.log(res.data);
          }
        })
        .catch((err) => {
          console.log(err.data);
        });
    },
    toggleInfoWindow: function (vehicle, cuenta) {
      this.infoWindowPos = vehicle.center;
      this.infoOptions.content = vehicle.infoText;
      if (this.currentMidx == cuenta) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = cuenta;
      }
    },
  },
  beforeMount() {},
  mounted() {
    this.$root.$emit("getList");
    this.$root.$on("send", (data) => {
      this.vehicles = data;
      this.setVehicles();
    });
    this.$root.$on("send_tag", (data) => {
      this.tags = data;
      this.setVehicles();
    });
    this.$root.$on("eventsAlerts", (data) => {
      this.getEventAlert();
    });
    this.getEventAlert();
    this.validateStatus();
  },
};
</script>
<style>
#map {
  min-height: calc(100vh - 135px);
  width: 70%;
}

#list {
  overflow: scroll;
  height: calc(100vh - 135px);
}
</style>
